import { isNil } from 'lodash';
import Swagger from '@mr_dj07/swagger-client';
import { setAuthUser } from '../data/actions';

const TokenExpiredError = 'TokenExpiredError';

class PhotoBoothApi {
  constructor(client) {
    this.api = client.apis;
    this.spec = client.spec;

    this._store = null;
  }

  async setBearerAuthToken(token) {
    if (token) {
      const options = {
        authorizations: {
          bearerAuth: token
        }
      };
      const client = await Swagger(process.env.API_DEF_URL, options);

      this.api = client.apis;
      this.spec = client.spec;
    }
  }

  get store() {
    return this._store;
  }

  set store(store) {
    this._store = store;
  }

  async call(tag, operation, parameters = null, payload = null) {
    const sanitizedPayload = !isNil(payload) ? { requestBody: payload } : undefined;
    try {
      const result = await this.api[tag][operation](parameters, sanitizedPayload);
      return result.obj;
    } catch (error) {
      if (
        error.response.body &&
        error.response.body.data &&
        error.response.body.data.name === TokenExpiredError
      ) {
        this._store.dispatch(setAuthUser(null));
        await this._store.dispatch(setAuthUser(null));
      }

      throw error;
    }
  }
}

export default PhotoBoothApi;



// WEBPACK FOOTER //
// ./src/services/PhotoBoothApi.js